export function getNow() {
    const now = new Date()
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000)
    const date = utc.getFullYear() + '-' + checkLength((utc.getMonth() + 1)) + '-' + checkLength(utc.getDate())
    const time = checkLength(utc.getHours()) + ":" + checkLength(utc.getMinutes()) + ":" + checkLength(utc.getSeconds())
    const dateTime = date + ' ' + time + ' (UTC)'
    return dateTime
}

export function getTimeForDepArr(){
    const now = new Date()
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000)
    const date =  utc.getFullYear()+ checkLength((utc.getMonth() + 1)) + checkLength(utc.getDate())
    const time = checkLength(utc.getHours()) + checkLength(utc.getMinutes())
    const dateTime = date+ time 
    return parseInt(dateTime)

}

export function getNowForLog() {
    const now = new Date()
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000)
    const time = checkLength(utc.getHours()) + ":" + checkLength(utc.getMinutes()) + ":" + checkLength(utc.getSeconds())
    const dateTime = time 
    return dateTime
}

export function getLocalNow() {
    const now = new Date()
    const time = checkLength(now.getHours()) + ":" + checkLength(now.getMinutes())
    const dateTime = time 
    return dateTime
}

function checkLength(num){
    let str = num.toString()
    if(str.length===1){
        return "0"+str
    } else{
        return str
    }
    
}

export function capitalizeWords(string) {
    let chars =string.split('')

    for (let i in chars){
        chars[i] = chars[i].toUpperCase()
    }
   
    return  chars.join("")
}

export function checkMobile(){
 
    var varUA = navigator.userAgent.toLowerCase()
 
    if ( varUA.indexOf('android') > -1) {
        return "android"
    } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
        return "ios"
    } else {
        return "other"
    }
}
